import { useEffect, useState } from 'react';

/** Drop files anywhere on a new or existing chat, including the sidebar. */
export function useFileDrop() {
  const [dragOver, setDragOver] = useState(false);
  const [droppedFiles, setDroppedFiles] = useState<File[]>([]);

  useEffect(() => {
    function onDragOver(e: DragEvent): void {
      if (!e.dataTransfer?.types.includes('Files')) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      setDragOver(true);
    }

    function onDragLeave(e: DragEvent): void {
      if (e.relatedTarget === null) setDragOver(false);
    }

    function onDrop(e: DragEvent): void {
      if (!e.dataTransfer?.types.includes('Files')) return;
      e.preventDefault();
      setDragOver(false);
      const files = Array.from(e.dataTransfer.files);
      if (files.length > 0) setDroppedFiles(files);
    }

    window.addEventListener('dragover', onDragOver, true);
    window.addEventListener('dragleave', onDragLeave);
    window.addEventListener('drop', onDrop, true);
    return () => {
      window.removeEventListener('dragover', onDragOver, true);
      window.removeEventListener('dragleave', onDragLeave);
      window.removeEventListener('drop', onDrop, true);
    };
  }, []);

  return { dragOver, droppedFiles, consumeDroppedFiles: () => setDroppedFiles([]) };
}
